/**
 * Returns true when the scanned address shape is valid for more than one
 * chain in the supported set AND the detector helper can't disambiguate.
 *
 * Three shapes qualify:
 *  - `3…` Base58 P2SH (Bitcoin and Litecoin both validate)
 *  - bare 64-hex (NEAR implicit, Sui, Aptos)
 *  - `0x` + 64-hex (Sui, Aptos)
 *
 * Bare `0x` + 40-hex EVM is NOT ambiguous in this sense — it defaults to
 * `eth` per the design invariant, with the send screen as the user-side
 * safety net (the same private key controls every EVM chain).
 *
 * Pure; no validators called.
 */
export function isAmbiguousAddress(address: string): boolean {
  const trimmed = address.trim()
  if (trimmed.length === 0) return false

  // 0x + 64 hex → Sui / Aptos
  if (/^0x[a-fA-F0-9]{64}$/.test(trimmed)) return true

  // Bare 64 hex → NEAR-implicit / Sui-stripped / Aptos-stripped
  if (/^[a-fA-F0-9]{64}$/.test(trimmed)) return true

  // Legacy P2SH `3…` → Bitcoin / Litecoin overlap
  if (/^3[1-9A-HJ-NP-Za-km-z]{25,34}$/.test(trimmed)) return true

  return false
}
